import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "@learningblocks/shared-components";
import "./style.scss";

import { useTranslation } from "react-i18next";

/**
 * ZoomDropdown:
 *  - Component renders the dropdown for PopupZoomImage
 */
export function ZoomDropdown(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  return (
    <div
      role="note"
      aria-label={`${t("ZoomValue.string")} ${props.value * 100}%`}
    >
      <Dropdown
        className="zoom-dropdown"
        placeholder="zoom"
        options={props.options}
        onChange={props.onChange}
        value={props.value}
      />
    </div>
  );
}

ZoomDropdown.propTypes = {
  /**
   * Function to involke when an option changes
   */
  onChange: PropTypes.func.isRequired,
  /**
   * List of options for drop down
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * value for zoom option
       */
      value: PropTypes.number,
      /**
       * Lable for zoom option
       */
      label: PropTypes.string,
    })
  ),
  /**
   * current zoom value
   */
  value: PropTypes.number,
};
